import { createReduxActionTypes } from '../../../utils/actionFactory';

const OPEN_DIALOG = 'OPEN_DIALOG';
const CLOSE_DIALOG = 'CLOSE_DIALOG';

export const actionTypes = createReduxActionTypes('ERROR_DIALOG', [
  OPEN_DIALOG,
  CLOSE_DIALOG
]);

const DEFAULT_STATE = {
  open: false,
  errorMessage: undefined
  
};

export const reducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case actionTypes[OPEN_DIALOG]: {
      const { dialogTitle, errorMessage,directMessage } = action;
      return {
        ...state,
        open: true,
        errorMessage,
        dialogTitle,
        directMessage
      };
    }
    case actionTypes[CLOSE_DIALOG]: {
      return { ...DEFAULT_STATE };
    }
    default:
      return state;
  }
};

export const actions = {
  openDialog: ({ errorMessage, dialogTitle,directMessage }) => ({
    type: actionTypes[OPEN_DIALOG],
    errorMessage,
    dialogTitle,
    directMessage
  }),
  closeDialog: () => ({ type: actionTypes[CLOSE_DIALOG] })
};
